import ContractorResource from "./contractor.resource";

const contractorModule = angular
  .module("app.resources.contractor", [])
  .service("Contractor", ContractorResource);

export default contractorModule;



// WEBPACK FOOTER //
// ./src/resources/contractor/contractor.module.js